import { useMemo, useState } from 'react'
import PaymentModal from './PaymentModal'
import { PaymentCurrency } from '../constants/paymentLinks'
import RecommendedChannels from './RecommendedChannels'

interface SubscriptionSectionProps {
  hasActiveSubscription: () => boolean
  subscription: any
  onSubscribeClick: () => void
  onSettingsClick: () => void
}

const SubscriptionSection = ({
  hasActiveSubscription,
  subscription,
  onSubscribeClick: _onSubscribeClick,
  onSettingsClick,
}: SubscriptionSectionProps) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
  const isActive = useMemo(
    () => hasActiveSubscription(),
    [hasActiveSubscription]
  )

  const formatSubscriptionDate = (dateString?: string) => {
    if (!dateString) return ''
    return new Date(dateString).toLocaleDateString('ru-RU')
  }

  const handleSubscribeClick = () => {
    setIsPaymentModalOpen(true)
  }

  const handleClosePaymentModal = () => {
    setIsPaymentModalOpen(false)
  }

  const handlePaymentSelect = (_currency: PaymentCurrency) => {
    // Переход к боту уже происходит в PaymentModal
    setIsPaymentModalOpen(false)
  }

  return (
    <>
      <div className="profile-section">
        <h2 className="section-title">Подписка</h2>
        {isActive ? (
          <>
            {subscription.expiresAt && (
              <div className="subscription-expires">
                <span className="subscription-label">Активна до:</span>
                <div className="subscription-date-badge">
                  {formatSubscriptionDate(subscription.expiresAt)}
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="subscription-status ">
              <span> Не активна</span>
            </div>
          </>
        )}
      </div>

      <button className="subscribe-button" onClick={handleSubscribeClick}>
        {isActive ? 'Продлить подписку' : 'Приобрести подписку'}
      </button>
      <button className="support-button" onClick={onSettingsClick}>
        Тех. поддержка
      </button>
      <RecommendedChannels defaultOpen={true} />

      <PaymentModal
        isOpen={isPaymentModalOpen}
        onClose={handleClosePaymentModal}
        onPaymentSelect={handlePaymentSelect}
      />
    </>
  )
}

export default SubscriptionSection
